import React from 'react'
import { useSortable } from '@dnd-kit/sortable'
import { CSS } from '@dnd-kit/utilities'
import { CardTitleTextfield } from '../index'

const SortableCard = ({ card, setSections, sections }) => {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({
    id: `card__${card.id}`, // Use prefixed card ID
  })

  const style = {
    transform: CSS.Transform.toString(transform),
    transition: transition || 'transform 100ms cubic-bezier(0.2, 0, 0, 1)',
    opacity: 1,
    position: 'relative',
    zIndex: isDragging ? 999 : 'auto',
    cursor: 'pointer',
  }

  return (
    <div
      ref={setNodeRef}
      style={style}
      {...attributes}
      {...listeners}
      id={`card-${card.id}`}
    >
      <CardTitleTextfield
        card={card}
        provided={{ dragHandleProps: listeners, ...attributes }}
        setSections={setSections}
        sections={sections}
      />
    </div>
  )
}

export default SortableCard
